import axios from "./axios-decorator";

const baseAxiosUrl = window.location.origin;

/**
* Get authentication meta data from API
* @param {String} windowLocationOriginDomain window location origin domain
* @param {String | Null} login_hint login hint
*/
export const getAuthenticationConsentMetadata = async (windowLocationOriginDomain: string, login_hint: string): Promise<any> => {
    let url = `${baseAxiosUrl}/api/authenticationMetadata/consentUrl?windowLocationOriginDomain=${windowLocationOriginDomain}&loginhint=${login_hint}`;

    console.log("call getAuthenticationConsentMetadata for the url : " + url);

    return await axios.get(url, undefined, false);
}